<template>
    <div class="sale-item sale-item-web-baner" v-if="banerArr != null && initItemBaner != false">
        <swiper :options="swiperOption" ref="promoCarousel">
            <swiper-slide v-for="(item, index) in banerArr" :key="index">
                <div class="baner-item" :style="'background-color:' + item.color_bg + ';'">
                    <a :href="item.link" target="_blank">
                        <!-- <newYear2021 :options="[{'amount' : 60, 'size' : 10, 'speed': 1}]"></newYear2021> -->
                        <img :src="item.baner_gif" alt="">
                    </a>
                </div>
            </swiper-slide>
        </swiper>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import newYear2021 from '@/components/newyear/newyear.vue'
    export default {
        name: 'sale-item-baner',
        components: {
            // newYear2021,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                banerArr: null,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                },
            }
        },
        computed: mapGetters({
            projectItems: 'loadProjectItems',
            cardAnimate: 'loadCardAnimateStatus',
            projectItemsDefault: 'loadProjectItemsDefault',
            banerSystem: 'loadBanerSystem',
            projectFilterCity: 'loadProjectItemsFilterCity',
            initItemBaner: 'loadSalesItemBaner',
        }),
        methods: {
            shortSalesItemsForBanerSystem() {
                var _self = this;
                var data = this.projectItems;
                var items = [];
                if (_self.baner_system_sales_active == 'true') {
                    // alert();
                    // console.log(data, 'sales_items_baner');
                    // items.push(data.slice(0,3));
                    // console.log(items);
                }
                return true;
            },
            shortSalesBaners() {
                // console.log('init short baners sales system')
                var data = this.banerSystem.sales_vertical_baners,
                    city = this.currentCity;
                if (this.projectFilterCity == null) {
                    this.banerArr = data;
                    // console.log('null');
                } else  {
                    var filteredItems = data.filter(item => {
                        return (
                            item.gorod.slug == this.projectFilterCity && 
                            // item.view_on_page.find(x => x == this.options[0].page) &&
                            item.baner_init == 'true'
                        );
                    });
                    // console.log(filteredItems);
                    if (filteredItems.length > 0) {
                        this.banerArr = _.shuffle(filteredItems);
                    } else {
                        this.banerArr = null;
                    }
                }
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.shortSalesBaners();
            // this.shortSalesItemsForBanerSystem();
            this.$store.watch(
                (state) => state.projectItemsFilterCity,
                (newValue) => {
                    this.shortSalesBaners();
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/realestate/sale-item.scss';
    @import '@/styles/respond/sales/respond-sale-item.scss';
</style>